export default __webpack_public_path__ + "static/media/new.4eb5fb7d.geojson";